import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme=>({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden',
   
  },
  table: {
    width: '100%',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'scroll',
      behavior: 'smooth' ,
      display:'block',
      width: '100%',
    }
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  },
  referenceCell: {
    width: '155px',
    paddingLeft: '20px',
    paddingRight: '0'
  },
  unitCell: {
    alignItems: 'center',
    minWidth: '300px',
    paddingRight: '20px',
    wordWrap: 'break-word'
  },
  unitContent: {
    display: 'flex',
    alignItems: 'center'
  },
  unitIcon: {
    fill: '#0E8BB4',
    display: 'inline',
    verticalAlign: 'bottom',
    marginRight: '10px'
  },
  title: {
    display: 'inline'
  },
  platformCell: {
    width: '96px',
    paddingLeft: '20px'
  },
  nameCell: {
    width: '155px',
    paddingRight: '20px',
    fontWeight: 'bold'
  },
  guestsCell: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '80px',
    width: '155px'
  },
  cellText: {
    display: 'flex',
    alignItems: 'center',
    height: '48px',
    marginRight: '10px'
  },
  orderIcon: {
    icon: {
      display: 'none'
    }
  },
  cancellationTimeCell: {
    width: '175px',
    paddingLeft: '70px'
  },

  statusCell: {
    width: '100px',
    color: '#717171!important',
     paddingLeft: '30px',
    [theme.breakpoints.down]:{
      width: '150px',
      paddingLeft: '30px',
    }
  },
  formControl: {
    minWidth: '90px',
    display: 'inline'
  },
  selectInput: {
    fontSize: '13px',
    color: '#717171',
    '&::before': {
      border: 'none'
    }
  },
  list: {
    padding: '10px',
    margin: '0',
    fontSize: '10px',
    color: '#FFFFFF'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  },
  disabledArea: {
    position: 'relative',
    '&::after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      background: 'black',
      opacity: 0.2
    }
  }
}));

export default useStyles;
